<template>
  <v-container fluid class="my-0 py-0">
    <v-row>
      <v-col sm="12">
        <v-skeleton-loader
          v-if="loading"
          type="text"
        />
        <v-toolbar v-else>
          <v-toolbar-title class="headline font-weight-bold">
            <v-icon left>fas fa-cog</v-icon>
            {{ tool.name }}
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn text :to="{ name: 'ToolProcessView', params: { name: tool.name }}">Process</v-btn>
            <v-btn text :to="{ name: 'ToolRecentRunsView', params: { name: tool.name }}">Process History</v-btn>
            <v-btn text :to="{ name: 'ToolStateHistoryView', params: { name: tool.name }}">Uptime</v-btn>
            <v-btn icon @click="saveJson"><v-icon>cloud_download</v-icon></v-btn>
            <v-btn icon @click="initialize"><v-icon>refresh</v-icon></v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </v-col>
    </v-row>
    <div>
      <v-skeleton-loader v-if="loading" />
      <router-view :id="tool.id" v-else />
    </div>
  </v-container>
</template>

<script>
import Tool from "../../models/Tool";
import { handleJSON } from "../../services/jsonDownload";
export default {
  name: "ToolView",
  props: {
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true
    };
  },
  computed: {
    tool() {
      return Tool.query()
        .where("name", this.name)
        .with("state")
        .first();
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      Tool
        .$get( this.name)
        .then(() => this.loading = false)
    },
    saveJson() {
      handleJSON(this.tool);
    }
  },
  mounted() {
    this.initialize();
  }
}
</script>
